import { useEffect } from "react";
import { useSettings } from "../lib/settings";

function setMeta(name, content, isProperty = false) {
  if (!content) return;
  const attr = isProperty ? "property" : "name";
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function SEOHead({ title, description, image }) {
  const { settings } = useSettings();

  useEffect(() => {
    const brand = settings?.brand_name || "This That For Me";
    const finalTitle = title || settings?.seo_title || `${brand} — Creator Marketplace`;
    const finalDesc = description || settings?.seo_description || "Curated AI prompts, ebooks, beauty, brand merch & affiliate picks.";
    const finalImage = image || settings?.seo_image || settings?.logo_url || "";
    const finalKeywords = settings?.seo_keywords || "";

    document.title = finalTitle;
    setMeta("description", finalDesc);
    if (finalKeywords) setMeta("keywords", finalKeywords);

    // Open Graph
    setMeta("og:title", finalTitle, true);
    setMeta("og:description", finalDesc, true);
    setMeta("og:site_name", brand, true);
    setMeta("og:type", "website", true);
    if (finalImage) setMeta("og:image", finalImage, true);

    // Twitter
    setMeta("twitter:card", finalImage ? "summary_large_image" : "summary");
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDesc);
    if (finalImage) setMeta("twitter:image", finalImage);
  }, [title, description, image, settings]);

  return null;
}
